import { Avatar } from '@mui/material';
import { HexColor } from '@repo/types/domain';
import styled from 'styled-components';

interface AvatarProps {
  initials?: string;
  imageUrl?: string;
  color?: HexColor;
  size?: number;
}

const ProfileAvatar = styled(Avatar)<AvatarProps>`
  && {
    background-color: ${({ color }) => color};
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
    font-size: calc(${({ size }) => size}px / 2.25);
    color: ${({ theme }) => theme.palette.common.white};
  }
`;

export { ProfileAvatar };
